import React, { useMemo } from 'react';
import GroupInvite from './Group';
import IdeaInvite from './Idea';
import RequestJoinIdea from './RequestJoinIdea';
import IdeaAssessorInvite from './IdeaAssessor';
import RequestJoinGroup from './RequestJoinGroup';
import ProjectInviteCard from './ProjectInvited';
import { InviteCardProps } from './types';

import styled from 'styled-components';

const NoteText = styled.span`
  font-size: 14px;
  color: #718096;
  white-space: pre-wrap;
`;

const InviteCard = ({ invitation, acceptInvite, rejectInvite, removeInvite }: InviteCardProps) => {
  const CardType = useMemo(() => {
    switch (invitation.forType) {
      case 'group': return GroupInvite;
      case 'idea': return IdeaInvite;
      case 'requestJoinIdea': return RequestJoinIdea;
      case 'ideaAssessor': return IdeaAssessorInvite;
      case 'requestJoinGroup': return RequestJoinGroup;
      case 'projectInvited': return ProjectInviteCard;
      default: return null;
    }
  }, [invitation]);

  return (
    <React.Fragment>
      {CardType ? (
        <>
          <CardType
            invitation={invitation}
            acceptInvite={acceptInvite}
            rejectInvite={rejectInvite}
            removeInvite={removeInvite}
            />
          {!invitation.acceptedBy && invitation.note ? <NoteText>"{invitation.note}"</NoteText> : null}
        </>) : null}
    </React.Fragment>
  );
}

export default InviteCard;
